import { NgModule } from '@angular/core';
import { Header } from './components/header/header';
import { MaterialModule } from './material-ui.module';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from './components/loading/loading.component';
import { CustomSnackbarComponent } from './services/toaster/custom-snackbar.component';
import { ErrorDialogComponent } from './components/error-dialog/error-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GenericTable } from './components/generic-table/generic-table';
import { SupportTicketDialogComponent } from './components/support-ticket-dialog/support-ticket-dialog.component';
import { AppContextDialogComponent } from './components/app-context-dialog/app-context-dialog.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { ConfirmRemarksDialogComponent } from './components/confirm-remarks-dialog/confirm-remarks-dialog.component';

@NgModule({
  imports: [MaterialModule, RouterModule, CommonModule, FormsModule, ReactiveFormsModule],
  exports: [
    Header,
    MaterialModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    LoadingComponent,
    ErrorDialogComponent,
    GenericTable,
    FormsModule,
    ReactiveFormsModule,
    AppContextDialogComponent,
    FileUploadComponent,
    ConfirmRemarksDialogComponent,
  ],
  declarations: [
    Header,
    LoadingComponent,
    CustomSnackbarComponent,
    ErrorDialogComponent,
    GenericTable,
    SupportTicketDialogComponent,
    AppContextDialogComponent,
    FileUploadComponent,
    ConfirmRemarksDialogComponent,
  ],
})
export class SharedModule {}
